import { observable, action, computed, makeObservable } from 'mobx';

import type { Optional } from 'chaika-common-types';

import { ItemMenu } from './ItemMenu';

type WithSubItems<U> = { subItems: U[] };

export class WithSubItemMenu<I extends WithSubItems<SI>, SI> {
    @observable
    protected items_: ItemMenu<I> = new ItemMenu();

    @observable
    protected subItems_: ItemMenu<SI> = new ItemMenu();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get selectedItemIndex(): Optional<number> {
        return this.items_.selectedIndex;
    }

    @computed
    public get selectedSubItemIndex(): Optional<number> {
        return this.subItems_.selectedIndex;
    }

    @computed
    public get itemsKeys(): number[] {
        return this.items_.keys;
    }

    @computed
    public get subItemsKeys(): number[] {
        return this.subItems_.keys;
    }

    @computed
    public get selectedItem(): Optional<I> {
        return this.items_.getSelectedItem();
    }

    @computed
    public get selectedSubItem(): Optional<SI> {
        return this.subItems_.getSelectedItem();
    }

    public set selectedItemIndex(index: Optional<number>) {
        this.items_.selectedIndex = index;

        const selectedItem = index === undefined ? undefined : this.items_.getItem(index);

        this.subItems_.items = selectedItem ? selectedItem.subItems : [];

        this.subItems_.selectedIndex = selectedItem && selectedItem.subItems.length > 0 ? 0 : undefined;
    }

    public set selectedSubItemIndex(index: Optional<number>) {
        this.subItems_.selectedIndex = index;
    }

    @action
    public setItems(items: I[]) {
        this.items_.items = items;
        this.subItems_.items = [];
    }

    public getItem(index: number): Optional<I> {
        return this.items_.getItem(index);
    }

    public getSubItem(index: number): Optional<SI> {
        return this.subItems_.getItem(index);
    }
}
